function generateMC(width, height, Illu, unit,media) {
    let multiplier=1;
    let val = 1;

    if(media==="Kiosk"){
        val = 1;
        switch (Illu) {
            case "BL":
                multiplier = 600;
                break;
            case "NL":
                multiplier = 350;
                break;
        }
    }else{
        val*=width * height * 5
    }
    if(unit){
        val *= unit;
    }
    return val*multiplier;
}

export default generateMC   